// Generated by CoffeeScript 2.7.0
// ==============================================================================
// PROJECTS - WELCOME
// ==============================================================================
import $ from "jquery";

$(function() {
  var $slides, currentNum, getIncreasedNumber, userAgent;
  // Automatically slide images in the top section
  $slides = $('#JS--welcome_slides');
  currentNum = 4;
  // Define Methods
  getIncreasedNumber = function(num) {
    if (++num > 4) {
      num = 1;
    }
    return num;
  };
  // Set Interval
  window.setInterval(function() {
    $slides.find(`li:nth-child(${currentNum})`).animate({
      left: '-100%'
    }, 1000, function() {
      return $(this).css({
        display: 'none'
      });
    });
    currentNum = getIncreasedNumber(currentNum);
    $slides.find(`li:nth-child(${currentNum})`).animate({
      left: 0
    }, 1000);
    return $slides.find(`li:nth-child(${getIncreasedNumber(currentNum)})`).css({
      display: 'block',
      left: '100%'
    });
  }, 4000);
  // Show 3nd campaign video
  $('.thumbs.slider').slick('slickGoTo', 2, true).slick('slickPlay');
  userAgent = navigator.userAgent;
  if (!!(userAgent.indexOf('iPhone') > 0 || userAgent.indexOf('iPad') > 0 || userAgent.indexOf('iPod') > 0)) {
    $('.js-download-button.is-android').css('display', 'none');
  }
  if (!!(userAgent.indexOf('Android') > 0)) {
    return $('.js-download-button.is-ios').css('display', 'none');
  }
});
